(function () {
  const SELECTOR = '[data-faq-footer-mobile]';

  function updateMobileExpand(root) {
    const mobile = root.querySelector('.faq-footer-mobile');
    if (!mobile) return;

    const hasOpen = root.querySelector('.faq-footer-mobile__item.is-open');
    mobile.classList.toggle('faq-footer-mobile--expanded', Boolean(hasOpen));
  }

  function closeOtherItems(root, exceptItem) {
    root.querySelectorAll('[data-faq-item].is-open').forEach(function (openItem) {
      if (openItem === exceptItem) return;

      openItem.classList.remove('is-open');
      const openTrigger = openItem.querySelector('[data-faq-trigger]');
      const openPanelId = openTrigger?.getAttribute('aria-controls');
      const openPanel = openPanelId ? document.getElementById(openPanelId) : null;

      if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
      if (openPanel) openPanel.setAttribute('aria-hidden', 'true');
    });
  }

  function toggleItem(trigger, root) {
    const item = trigger.closest('[data-faq-item]');
    if (!item || !root.contains(item)) return;

    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    const nextOpen = !isOpen;

    if (nextOpen) closeOtherItems(root, item);

    trigger.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
    item.classList.toggle('is-open', nextOpen);

    if (panel) {
      panel.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
    }

    window.requestAnimationFrame(function () {
      updateMobileExpand(root);
    });
  }

  function bindRoot(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.faqMobileBound === 'true') return;
    root.dataset.faqMobileBound = 'true';

    root.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      toggleItem(trigger, root);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      toggleItem(trigger, root);
    });

    updateMobileExpand(root);
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll(SELECTOR).forEach(updateMobileExpand);
  });

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target;
    if (!(section instanceof HTMLElement)) return;
    const root = section.querySelector(SELECTOR);
    if (root instanceof HTMLElement) bindRoot(root);
  });
})();
